<section
  class="margin-top confidential-scanning-section"
  aria-labelledby="confidential-scanning-heading"
  [class.disabled]="disabled()"
>
  <div class="d-flex align-items-center">
    <div id="confidential-scanning-heading" class="label">{{ 'confidential_scanning' | translate }}</div>
    @if (hasTooltip()) {
      <button
        type="button"
        ds-button
        class="info-icon margin-left-sm"
        id="confidential-scanning-heading-tooltip"
        data-test-id="confidential-scanning-heading-tooltip"
        [ds-tooltip]="tooltipText()"
        [tooltipPlacement]="DsTooltipPosition.top"
        [attr.aria-label]="tooltipText()"
      >
        <app-icon icon="question-mark-2"></app-icon>
      </button>
    }
  </div>
  <p class="mb-1" id="confidential-scanning-description">{{ 'confidential_scanning_description' | translate }}</p>
  <app-toggle-switch
    name="ConfidentialScanning"
    data-test-id="confidential-scanning-switch"
    [value]="value()"
    [disabled]="disabled()"
    (valueChange)="onValueChange($event)"
    switchContainerClass="d-flex align-items-center mt-2"
    [attr.aria-describedby]="ariaDescribedBy()"
  >
    <span class="switch-label">{{ 'enable_confidential_scanning_switch' | translate }}</span>
  </app-toggle-switch>
</section>
